// OAuth endpoints must return JSON, but gateways/deployments can return HTML.
// Never display the raw body or attempt to navigate to an unverified link.
export const readConnectionResponse = async (response) => {
  const type = (response.headers.get('content-type') || '').split(';')[0].toLowerCase();
  const reference = response.headers.get('x-request-id');
  const ref = reference && /^[a-zA-Z0-9_-]{1,80}$/.test(reference) ? ` Reference: ${reference}.` : '';
  if (type !== 'application/json' && !type.endsWith('+json')) {
    throw new Error(response.status >= 500
      ? `The connection service is temporarily unavailable (HTTP ${response.status}). Please try again shortly.${ref}`
      : `The connection service returned a webpage instead of connection data (HTTP ${response.status}).${ref}`);
  }
  let data;
  try { data = await response.json(); }
  catch { throw new Error(`The connection service returned invalid connection data (HTTP ${response.status}).${ref}`); }
  if (!response.ok) {
    const message = typeof data?.detail === 'string' ? data.detail : 'Unable to start this connection.';
    const id = typeof data?.request_id === 'string' && /^[a-zA-Z0-9_-]{1,80}$/.test(data.request_id) ? ` Reference: ${data.request_id}.` : ref;
    throw new Error(`${message.slice(0, 500)}${id}`);
  }
  try {
    const url = new URL(data.authUrl);
    if (url.protocol !== 'https:' || url.username || url.password) throw new Error();
  } catch { throw new Error('The connection service did not return a valid secure sign-in link.'); }
  return data;
};